module.exports = __webpack_public_path__ + "static/media/2.f485a172.png";